import { Component, HostListener } from '@angular/core';
import { NavigationHistory } from '@common/helpers/navigation-history';
import { BrowserNotificationService } from '@common/services/browser-notification/browser-notification.service';
import { SessionDataService } from '@common/services/session/session-data.service';
import { LoggingService } from '@common/services/utility/logging.service';
import { v4 as uuids4 } from 'uuid';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @HostListener('window:focus')
  onWindowFocus(): void {
    this.browserNotificationService.onWindowFocus();
  }

  @HostListener('window:blur')
  onWindowBlur(): void {
    this.browserNotificationService.onWindowBlur();
  }
  constructor(
    private navigationHistory: NavigationHistory,
    private readonly browserNotificationService: BrowserNotificationService,
    private readonly sessionStorageService: SessionDataService,
    private readonly loggerService: LoggingService,
  ) {
    const sessionId = this.sessionStorageService.get(SessionDataService.SessionId);

    if (!sessionId) {
      this.sessionStorageService.save(SessionDataService.SessionId, uuids4());
    }
    //TODO: reseach service injection into ngrx reducers
    // https://stackoverflow.com/questions/58066622/ngrx-how-to-use-services-in-meta-reducers
    LoggingService.logger = loggerService;
  }
  title = 'app';
}
